module.exports = __webpack_public_path__ + "static/media/tick-check-blue.62e1cf36.svg";